import { RadioItem } from '../helpers/radioItem'

export const LRSearchOption = (props) => {
  return (
    <div className="lr-search-options">
      <RadioItem
			key={'item1211qq'}
			value={''}
			selected={''}
			texthead={'LR Number'}
			textbody={''}
			onChange={()=>{}} />
			<RadioItem
			key={'item1211q2q'}
			value={''}
			selected={''}
			texthead={'Mannual LR Number'}
			textbody={''}
			onChange={()=>{}} />
			<RadioItem
			key={'item121s1qq'}
			value={''}
			selected={''}
			texthead={'Challan Number'}
			textbody={''}
			onChange={()=>{}} />
			
    </div>
  )
}
